import { createFileRoute, redirect } from "@tanstack/react-router";

/** Dubblett av ordlistesidan – permanent omdirigering. */
export const Route = createFileRoute("/elpriskollen")({
  beforeLoad: () => {
    throw redirect({ to: "/ordlista/$term", params: { term: "elpriskollen" }, statusCode: 301 });
  },
});
